import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { Authentication } from "../types/Authentication";

export enum AuthenticationStatus {
  Authenticated,
  RequiresAuthentication,
  Unauthenticated,
  Unknown,
}

const LOCAL_STORAGE_AUTH_KEY = "auth";
export const AUTHENTICATION_ENDPOINT = "https://api.saneetbhella.co.uk/finance/auth";

export const InitiateAuth = () => {
  const [token, setToken] = useState<string | null>(null);
  const [authenticationStatus, setAuthenticationStatus] = useState<AuthenticationStatus>(AuthenticationStatus.Unknown);

  const authenticate = useCallback(async (password: string) => {
    if (!password) {
      return setAuthenticationStatus(AuthenticationStatus.Unauthenticated);
    }

    setAuthenticationStatus(AuthenticationStatus.Unknown);

    try {
      const response = await axios.post<Authentication>(AUTHENTICATION_ENDPOINT, {
        password,
      });

      setAuthenticationStatus(AuthenticationStatus.Authenticated);
      setToken(response.data.token);

      const newAuth = {
        token: response.data.token,
        expiry: Math.floor(new Date().getTime() / 1000) + response.data.expiry,
      };

      localStorage.setItem(LOCAL_STORAGE_AUTH_KEY, JSON.stringify(newAuth));
    } catch (err: any) {
      setAuthenticationStatus(AuthenticationStatus.Unauthenticated);
      console.error(err);
    }
  }, []);

  useEffect(() => {
    function getToken() {
      try {
        const auth = localStorage.getItem(LOCAL_STORAGE_AUTH_KEY);
        if (auth) {
          const authData = JSON.parse(auth) as Authentication;
          if (Math.floor(new Date().getTime() / 1000) < authData.expiry) {
            setAuthenticationStatus(AuthenticationStatus.Authenticated);
            setToken(authData.token);
            return;
          }
        }

        setAuthenticationStatus(AuthenticationStatus.RequiresAuthentication);
      } catch (err: any) {
        setAuthenticationStatus(AuthenticationStatus.Unauthenticated);
        console.error(err);
      }
    }
    getToken();
  }, []);

  return { authenticate, authenticationStatus, token };
};
